<template>
  <div class="bg-white frame">
    <div class="frame-content" style="height: 60px;" flex="dir:left cross:center">
      <div class="f-24 f-w-800">{{ mapConfig.baseJson.title }}</div>
    </div>

    <div class="frame-content" flex="dir:top cross:center">
      <img :src="mapConfig.adImg">
      <a-icon type="info-circle" theme="twoTone" style="font-size: 96px" class="m-t-64 m-b-32"/>
      <div class="f-20 c-gray-7">您的注册数据正在向印章备案系统同步，请等待一段时间后再次尝试，非工作日顺延，给您带来不便请谅解。</div>
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState({
      mapConfig: state => state.main.config,
    })
  },
  methods: {},
  created() {

  }
}
</script>
